import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.TradingHistory.title',
        defaultMessage: 'Add your trading history'
    },
    infoRequired: {
        id: '_.TradingHistory.info_required',
        defaultMessage:
            'We require the information below to complete your application. Give us a call on {phoneNumber} or  email on {email} if you need help or are not able to provide something'
    },
    infoRequired_tel: {
        id: '_.TradingHistory.info_required_tel',
        defaultMessage: '02037780274'
    },
    infoRequired_tel_display: {
        id: '_.TradingHistory.info_required_tel_display',
        defaultMessage: '0203 778 0274'
    },
    infoRequired_email: {
        id: '_.TradingHistory.info_required_email',
        defaultMessage: 'support@iwoca.co.uk'
    },
    preparingRequirements: {
        id: '_.TradingHistory.preparing_requirements',
        defaultMessage: 'We’re preparing your requirements...'
    },
    optionalTitle: {
        id: '_.TradingHistory.optional_title',
        defaultMessage: 'Some optional extras'
    },
    optionalRequirements: {
        id: '_.TradingHistory.optional_requirements',
        defaultMessage:
            'These documents aren’t mandatory, but including them would help us get a clearer picture of your business.'
    },
    nearlyThere: {
        id: '_.TradingHistory.nearly_there',
        defaultMessage: "You're nearly there!"
    },
    submitCTA: {
        id: '_.TradingHistory.submit',
        defaultMessage: 'Send your application'
    }
});
